/** Contenido SEO de páginas del mega menú (ortodoncia en Cusco). */

const page = (seoTitle, seoDescription, h1, intro, sections, benefits, visual) => ({
  seoTitle,
  seoDescription,
  h1,
  intro,
  sections,
  benefits,
  visualStepsHeading: visual?.heading ?? null,
  visualSteps: visual?.steps ?? null,
  heroImageAlt: visual?.heroImageAlt ?? null,
});

export const orthoPagesEs = {
  common: {
    bookCta: 'Reserva tu evaluación ortodóncica',
    backHome: 'Volver al inicio',
    trust1: 'Dr. Germán Paniura · Ortodoncista',
    trust2: 'Brackets y alineadores en Cusco',
    trust3: 'Atención local e internacional',
    benefitsTitle: 'Por qué confiar en mi consulta',
    ctaTitle: '¿Listo para tu evaluación?',
    ctaText:
      'Agenda tu primera cita en línea. Te explico opciones, tiempos estimados y cuidados desde el primer día, sin tecnicismos innecesarios.',
  },
  pages: {
    metalBraces: page(
      'Brackets metálicos en Cusco | Ortodoncia fija | Smile Up',
      'Brackets metálicos en Cusco: ortodoncia fija efectiva para niños, jóvenes y adultos. Evaluación, plan de tratamiento y controles con el Dr. Paniura, Av. La Cultura 822.',
      'Brackets metálicos en Cusco',
      'Los brackets metálicos siguen siendo una de las opciones más confiables para corregir apiñamiento, mordida cruzada y espacios. En mi consulta en Cusco planifico tu tratamiento con controles periódicos y te explico cada paso con claridad en cada visita.',
      {
        s1: {
          title: '¿Cuándo recomiendo brackets metálicos?',
          p1: 'Son ideales cuando se necesita control preciso de cada diente, especialmente en casos moderados o complejos. También suelen ser la opción más accesible dentro de la ortodoncia fija en Cusco.',
          p2: 'Durante la evaluación reviso radiografías, fotografías y modelos para definir si los brackets metálicos son la mejor alternativa frente a brackets estéticos o alineadores.',
        },
        s2: {
          title: 'Cómo es el tratamiento en mi consulta',
          p1: 'El proceso incluye colocación inicial, ajustes cada 4–6 semanas y educación sobre higiene con brackets. Adapto el plan si viajas o vives fuera de Cusco, coordinando citas cuando sea posible.',
        },
        s3: {
          title: 'Duración y resultados',
          p1: 'El tiempo varía según la complejidad del caso; muchos tratamientos duran entre 18 y 24 meses. Mi objetivo es una sonrisa alineada y una mordida funcional, con retenedores al finalizar.',
        },
      },
      {
        b1: 'Control detallado de movimientos dentarios',
        b2: 'Opción robusta para casos complejos',
        b3: 'Seguimiento cercano con el Dr. Paniura',
        b4: 'Atención en español e inglés',
      },
      {
        heroImageAlt:
          'Joven sonriendo mostrando sus brackets metálicos durante tratamiento de ortodoncia',
      }
    ),
    ceramicBraces: page(
      'Brackets estéticos en Cusco | Brackets cerámicos | Smile Up',
      'Brackets cerámicos o estéticos en Cusco: ortodoncia fija discreta con la misma eficacia que los metálicos. Consulta con el Dr. Paniura, ortodoncia para adultos y jóvenes.',
      'Brackets estéticos en Cusco',
      'Los brackets cerámicos combinan la precisión de la ortodoncia fija con un aspecto más discreto. En Cusco, muchos pacientes adultos y profesionales eligen esta opción para alinear su sonrisa sin renunciar a la estética durante el tratamiento.',
      {
        s1: {
          title: 'Brackets cerámicos vs metálicos',
          p1: 'Los brackets estéticos funcionan igual que los metálicos, pero su color se asemeja al del diente. Son una excelente alternativa cuando la imagen profesional o personal es importante durante el tratamiento.',
        },
        s2: {
          title: 'Cuidados y recomendaciones',
          p1: 'Requieren la misma higiene rigurosa que los brackets metálicos y evitar alimentos muy duros o pigmentados que puedan manchar la ligadura. En cada control reviso el estado de los brackets y ajusto el arco.',
        },
        s3: {
          title: 'Evaluación personalizada en Cusco',
          p1: 'No todos los casos requieren la misma técnica. En la primera consulta comparo brackets estéticos, metálicos e Invisalign según tus objetivos, tiempo disponible y presupuesto.',
        },
      },
      {
        b1: 'Aspecto más natural durante el tratamiento',
        b2: 'Misma eficacia que brackets metálicos',
        b3: 'Ideal para adultos en Cusco',
        b4: 'Plan claro desde la primera visita',
      },
      {
        heroImageAlt:
          'Paciente con brackets cerámicos estéticos durante tratamiento de ortodoncia en Cusco',
      }
    ),
    invisalign: page(
      'Invisalign en Cusco | Alineadores transparentes | Smile Up',
      'Invisalign y alineadores transparentes en Cusco. Ortodoncia removible, cómoda y discreta con seguimiento del Dr. Germán Paniura. Reserva tu evaluación en Smile Up.',
      'Invisalign y alineadores en Cusco',
      'Los alineadores transparentes permiten corregir la posición dental sin brackets visibles. En mi consulta en Cusco ofrezco tratamiento con alineadores —incluido Invisalign cuando corresponde— con escaneos, plan digital y controles programados.',
      {
        s1: {
          title: '¿Para quién son los alineadores?',
          p1: 'Funcionan bien en apiñamientos leves a moderados, espacios y algunas correcciones de mordida. En la evaluación confirmo si tu caso es compatible o si conviene combinar alineadores con ortodoncia fija.',
        },
        s2: {
          title: 'Ventajas de los alineadores removibles',
          p1: 'Puedes retirarlos para comer y cepillarte, lo que facilita la higiene. Son discretos en fotos y reuniones, una ventaja para pacientes internacionales que visitan Cusco o viven temporalmente en la ciudad.',
        },
        s3: {
          title: 'Compromiso y seguimiento',
          p1: 'El éxito depende de usar los alineadores 20–22 horas al día. Programo revisiones para entregar nuevas series y verificar que el movimiento avance según el plan digital.',
        },
      },
      {
        b1: 'Tratamiento discreto y removible',
        b2: 'Provider Invisalign en Cusco',
        b3: 'Planificación digital del tratamiento',
        b4: 'Adecuado para viajeros con seguimiento planificado',
      },
      {
        heroImageAlt:
          'Paciente con alineadores transparentes Invisalign durante ortodoncia en Cusco',
      }
    ),
    selfLigatingBraces: page(
      'Brackets autoligantes en Cusco | Ortodoncia fija | Smile Up',
      'Brackets autoligantes en Cusco: ortodoncia fija con menos fricción y controles más cómodos. Evaluación y plan de tratamiento con el Dr. Paniura, Av. La Cultura 822.',
      'Brackets autoligantes en Cusco',
      'Los brackets autoligantes utilizan un sistema de cierre integrado que reduce la fricción entre el arco y el bracket. En mi consulta en Cusco los indico cuando buscas ortodoncia fija eficaz con visitas de control más cómodas y, en muchos casos, intervalos más espaciados entre citas.',
      {
        s1: {
          title: '¿En qué se diferencian de los brackets convencionales?',
          p1: 'A diferencia de los brackets metálicos o estéticos con ligaduras elásticas, los autoligantes mantienen el arco con un mecanismo de cierre propio. Eso puede traducirse en menos presión inicial y movimientos más suaves en etapas seleccionadas del tratamiento.',
          p2: 'No sustituyen el diagnóstico ni el seguimiento profesional: en la evaluación confirmo si tu caso se beneficia de autoligantes frente a otras opciones fijas o alineadores.',
        },
        s2: {
          title: 'Ventajas que explico en consulta',
          p1: 'Muchos pacientes reportan mayor comodidad tras los ajustes y una higiene algo más sencilla al no depender de ligaduras que retienen placa. También valoro su utilidad en apiñamientos moderados y en adultos que desean ortodoncia fija con controles predecibles.',
        },
        s3: {
          title: 'Tratamiento y seguimiento en Cusco',
          p1: 'El plan incluye colocación, activaciones periódicas y educación sobre cuidados con brackets. Si vives fuera de Cusco o viajas, coordinamos citas para que avances sin perder continuidad en tu tratamiento.',
        },
      },
      {
        b1: 'Ortodoncia fija con sistema de cierre integrado',
        b2: 'Controles cómodos y plan personalizado',
        b3: 'Seguimiento cercano con el Dr. Paniura',
        b4: 'Atención en español e inglés',
      },
      {
        heroImageAlt:
          'Brackets autoligantes durante tratamiento de ortodoncia en Cusco',
      }
    ),
    klamm: page(
      'Aparato Klammt | Ortopedia maxilar | Smile Up',
      'Aparatología Klammt para ortopedia maxilar infantil. Guía el crecimiento y corrige hábitos en niños y adolescentes con el Dr. Paniura.',
      'Aparato Klammt',
      'El aparato Klammt es una placa funcional removible que aprovecha el crecimiento para orientar maxilares y mandíbula. En mi consulta lo indico en casos seleccionados de ortopedia maxilar, siempre tras una evaluación clínica y radiográfica completa.',
      {
        s1: {
          title: '¿Qué es el aparato Klammt?',
          p1: 'Es un dispositivo ortopédico que combina guía ósea y reeducación muscular. Su diseño permite intervenir en etapas de crecimiento activo, cuando el maxilar y la mandíbula aún pueden modificarse de forma más conservadora.',
        },
        s2: {
          title: 'Indicaciones en niños y adolescentes',
          p1: 'Puede indicarse en mordidas clase II leves a moderadas, hábitos como respiración bucal o protrusión lingual, y ciertas asimetrías en desarrollo. Evalúo edad, cooperación del paciente y objetivos familiares antes de recomendarlo.',
        },
        s3: {
          title: 'Uso, controles y fases siguientes',
          p1: 'Explico horas de uso diario, higiene del aparato y señales de alarma entre citas. El Klammt puede formar parte de un plan por etapas que continúa con ortodoncia completa si el caso lo requiere.',
        },
      },
      {
        b1: 'Interceptación en etapa de crecimiento',
        b2: 'Plan personalizado por edad',
        b3: 'Seguimiento con el Dr. Paniura',
        b4: 'Consulta en Av. La Cultura 822',
      },
      {
        heroImageAlt: 'Aparato Klammt de ortopedia maxilar para tratamiento',
      }
    ),
    bimler: page(
      'Aparato Bimler | Ortopedia funcional | Smile Up',
      'Técnica Bimler: aparatología funcional para corregir hábitos y armonizar maxilares en niños y adolescentes. Evaluación con el Dr. Paniura.',
      'Aparato Bimler',
      'La técnica Bimler utiliza aparatos funcionales que estimulan patrones musculares correctos mientras guían el desarrollo maxilomandibular. La aplico cuando el diagnóstico indica reeducación funcional combinada con control del crecimiento.',
      {
        s1: {
          title: 'Fundamento de la técnica Bimler',
          p1: 'Se basa en equilibrar fuerzas musculares — lengua, labios y músculos faciales — para favorecer una relación maxilomandibular más armónica durante el crecimiento.',
        },
        s2: {
          title: '¿Cuándo lo recomiendo?',
          p1: 'En pacientes en crecimiento con alteraciones funcionales, mordida clase II en desarrollo o hábitos que interfieren con la oclusión. La cooperación del niño y el compromiso familiar son claves para el éxito.',
        },
        s3: {
          title: 'Controles y evolución del tratamiento',
          p1: 'Programo revisiones periódicas para ajustar el aparato y verificar avances. Si tras la fase funcional persisten desalineaciones dentales, planifico ortodoncia con brackets o alineadores.',
        },
      },
      {
        b1: 'Enfoque funcional y muscular',
        b2: 'Indicado en crecimiento activo',
        b3: 'Explicación clara a padres',
        b4: 'Atención en español e inglés',
      },
      {
        heroImageAlt: 'Aparato Bimler de ortopedia maxilar en consulta ortodóncica',
      }
    ),
    planas: page(
      'Placas Planas | Ortopedia interceptiva | Smile Up',
      'Placas Planas para ortopedia maxilar interceptiva en niños. Corrige hábitos y prepara la dentición con el Dr. Paniura, Av. La Cultura 822.',
      'Placas Planas',
      'Las placas Planas son dispositivos activos que combinan elementos de soporte y activación para modificar hábitos y posición dentaria en la infancia. En mi consulta las indico como parte de tratamientos interceptivos personalizados.',
      {
        s1: {
          title: '¿Qué son las placas Planas?',
          p1: 'Son aparatos removibles con tornillos o elementos activos que permiten pequeñas correcciones dentarias y reeducación de funciones orales, aprovechando la flexibilidad del periodo de crecimiento.',
        },
        s2: {
          title: 'Problemas que pueden abordar',
          p1: 'Apiñamientos leves, mordida abierta incipiente, hábitos de succión prolongados y desviaciones funcionales leves. La evaluación temprana define si una placa Plana es suficiente o conviene otra aparatología.',
        },
        s3: {
          title: 'Cuidados y seguimiento',
          p1: 'Indico tiempo de uso, limpieza del aparato y revisiones para activar o ajustar la placa. El objetivo es simplificar tratamientos futuros y estabilizar un desarrollo maxilofacial más favorable.',
        },
      },
      {
        b1: 'Tratamiento interceptivo activo',
        b2: 'Aparatología removible personalizada',
        b3: 'Evaluación ortodóncica infantil',
        b4: 'Consulta en Av. La Cultura 822, Wanchaq',
      },
      {
        heroImageAlt: 'Placas Planas de ortopedia maxilar para niños',
      }
    ),
    stockfisch: page(
      'Aparato Stockfisch | Ortopedia maxilar | Smile Up',
      'Aparato Stockfisch: ortopedia funcional para armonizar maxilares en crecimiento. Evaluación y plan con el Dr. Paniura.',
      'Aparato Stockfisch',
      'El aparato Stockfisch es un dispositivo funcional que ayuda a equilibrar el desarrollo maxilomandibular en pacientes en crecimiento. Lo utilizo dentro de planes de ortopedia maxilar cuando el patrón esquelético y funcional lo justifica.',
      {
        s1: {
          title: 'Características del aparato Stockfisch',
          p1: 'Diseñado para influir en la relación entre maxilar superior e inferior mediante guía funcional, favoreciendo posiciones más estables de la mordida durante el desarrollo.',
        },
        s2: {
          title: 'Indicaciones frecuentes',
          p1: 'Discrepancias esqueléticas leves a moderadas en crecimiento, alteraciones de la vía aérea asociadas a postura mandibular y casos que requieren preparar la arcada antes de ortodoncia fija.',
        },
        s3: {
          title: 'Plan por etapas',
          p1: 'Explico duración estimada, uso diario y metas de cada fase. Tras completar la ortopedia funcional, valoro si el paciente necesita brackets, alineadores o solo retención.',
        },
      },
      {
        b1: 'Armonización maxilomandibular',
        b2: 'Aprovecha etapas de crecimiento',
        b3: 'Diagnóstico basado en examen completo',
        b4: 'Seguimiento cercano con el Dr. Paniura',
      },
      {
        heroImageAlt: 'Aparato Stockfisch de ortopedia maxilar en tratamiento',
      }
    ),
    clarkTwinBlock: page(
      'Clark Twin Block | Ortopedia funcional Clase II | Smile Up',
      'Clark Twin Block para corregir Clase II en crecimiento. Bloques gemelos y ortopedia funcional con el Dr. Paniura, Av. La Cultura 822.',
      'Clark Twin Block',
      'El Clark Twin Block es un aparato funcional de bloques gemelos muy utilizado para avanzar la mandíbula en pacientes con Clase II en crecimiento. En mi consulta lo indico cuando el diagnóstico y la edad del paciente son compatibles con esta terapia.',
      {
        s1: {
          title: '¿Cómo funciona el Twin Block?',
          p1: 'Consta de dos placas — superior e inferior — con rampas que guían la mandíbula hacia una posición más adelantada al cerrar la boca, estimulando adaptación esquelética y muscular.',
        },
        s2: {
          title: '¿Para quién está indicado?',
          p1: 'Principalmente en niños y adolescentes en pico de crecimiento con Clase II esquelética o funcional. Valoro maduración ósea, espacio disponible y cooperación antes de iniciar.',
        },
        s3: {
          title: 'Duración y fase siguiente',
          p1: 'El tratamiento suele durar varios meses con uso casi a tiempo completo. Tras estabilizar la mejora, puedo indicar retención, placas de transición o iniciar ortodoncia con brackets o alineadores.',
        },
      },
      {
        b1: 'Referente en ortopedia Clase II',
        b2: 'Aparatología probada en crecimiento',
        b3: 'Plan claro para padres y pacientes',
        b4: 'Evaluación en Smile Up',
      },
      {
        heroImageAlt: 'Aparato Clark Twin Block de ortopedia maxilar',
      }
    ),
    retainers: page(
      'Retenedores en Cusco | Mantén tu sonrisa | Smile Up',
      'Retenedores fijos y removibles en Cusco tras brackets o alineadores. Evita recaídas y conserva tu nueva sonrisa. Retención ortodóncica con el Dr. Paniura, Cusco.',
      'Retenedores ortodóncicos en Cusco',
      'Terminar brackets o alineadores no es el final del camino: los retenedores mantienen los dientes en su nueva posición mientras el hueso y las encías se estabilizan. En mi consulta indico el tipo de retención según tu caso.',
      {
        s1: {
          title: 'Tipos de retenedores',
          p1: 'Los retenedores removibles (como placas transparentes nocturnas) y los fijos (alambre detrás de los incisivos) cumplen funciones complementarias. Elijo la combinación que mejor proteja tu resultado.',
        },
        s2: {
          title: 'Tiempo de uso y controles',
          p1: 'Al inicio suele usarse casi todo el día; con el tiempo pasa a uso nocturno prolongado. Las revisiones permiten ajustar o reemplazar el retenedor si se pierde o deforma.',
        },
        s3: {
          title: 'Pacientes de Cusco y visitantes',
          p1: 'Si completaste tu tratamiento fuera de la ciudad, puedo fabricar o revisar retenedores durante tu estancia en Cusco. Trae modelos o radiografías si las tienes.',
        },
      },
      {
        b1: 'Protección contra recaídas',
        b2: 'Opciones fijas y removibles',
        b3: 'Indicaciones claras de uso',
        b4: 'Seguimiento post-tratamiento',
      },
      {
        heroImageAlt:
          'Retenedor ortodóncico removible Hawley sobre modelo dental para retención post-tratamiento',
      }
    ),
    miniImplants: page(
      'Microimplantes ortodóncicos en Cusco | Anclaje auxiliar | Smile Up',
      'Microimplantes ortodóncicos (TADs) en Cusco para movimientos dentales complejos. Anclaje temporal seguro dentro del plan de brackets o alineadores con el Dr. Paniura.',
      'Microimplantes ortodóncicos en Cusco',
      'Los microimplantes —tornillos temporales de anclaje— ayudan a mover dientes difíciles sin depender de otros dientes como punto de apoyo. El especialista los indica en casos seleccionados dentro de un plan de ortodoncia integral en Cusco.',
      {
        s1: {
          title: '¿Cuándo se indican?',
          p1: 'Son útiles para cerrar espacios, intruir molares, corregir mordidas abiertas o mover un diente anclado sin afectar el resto de la arcada. La decisión la tomo tras estudio radiográfico y análisis del caso.',
        },
        s2: {
          title: 'Colocación y molestias',
          p1: 'La instalación es ambulatoria bajo anestesia local. La mayoría de pacientes reporta presión leve unos días. Retiro el microimplante al cumplir su función, sin dejar implante permanente.',
        },
        s3: {
          title: 'Integración con tu tratamiento',
          p1: 'Forman parte del plan global con brackets o alineadores. Te explico por qué se necesitan, cuánto tiempo permanecen y cómo cuidar la zona durante su uso.',
        },
      },
      {
        b1: 'Mayor control en casos complejos',
        b2: 'Procedimiento mínimamente invasivo',
        b3: 'Retiro al finalizar su función',
        b4: 'Plan coordinado por el especialista',
      },
      {
        heroImageAlt:
          'Microimplante ortodóncico de anclaje temporal (TAD) para tratamientos complejos en Cusco',
      }
    ),
    thirdMolar: page(
      'Cirugía de tercer molar en Cusco | Muelas del juicio | Smile Up',
      'Extracción de terceros molares en Cusco cuando el plan ortodóncico lo requiere. Cirugía de muelas del juicio coordinada con tu tratamiento por el Dr. Paniura.',
      'Cirugía de tercer molar en Cusco',
      'Las muelas del juicio pueden interferir con el alineamiento o empujar dientes ya corregidos. Cuando el plan ortodóncico lo indica, coordino la extracción de terceros molares con cuidado postoperatorio claro.',
      {
        s1: {
          title: 'Relación con la ortodoncia',
          p1: 'A veces conviene extraer antes de cerrar espacios; otras veces, al final del tratamiento. Evalúo posición, espacio disponible e impactación con radiografía panorámica.',
        },
        s2: {
          title: 'Procedimiento y recuperación',
          p1: 'Realizo la cirugía con anestesia local y protocolos de asepsia. Te indico analgesia, dieta blanda e higiene de la zona. La mayoría retoma actividades ligeras en pocos días.',
        },
        s3: {
          title: 'Viajeros en Cusco',
          p1: 'Si estás de paso, planifico la extracción con margen de recuperación antes de tu vuelo o bus. Priorizo tu seguridad y te comunico tiempos realistas.',
        },
      },
      {
        b1: 'Decisión basada en radiografía',
        b2: 'Coordinación con ortodoncia activa',
        b3: 'Indicaciones postoperatorias claras',
        b4: 'Atención en español e inglés',
      },
      {
        heroImageAlt:
          'Evaluación ortodóncica y planificación de cirugía de tercer molar en Cusco',
      }
    ),
    drProfile: page(
      'Dr. Germán Paniura | Ortodoncista en Cusco | Smile Up',
      'Conoce al Dr. Germán Paniura, ortodoncista en Cusco. Especialista en brackets, alineadores e ortopedia maxilar en Smile Up, Av. La Cultura 822.',
      'Dr. Germán Paniura, ortodoncista en Cusco',
      'Soy el Dr. Germán Paniura y dirijo Smile Up en Cusco. Mi enfoque combina diagnóstico riguroso, comunicación directa y planes de tratamiento adaptados a pacientes locales e internacionales.',
      {
        s1: {
          title: 'Formación y experiencia',
          p1: 'Soy especialista en ortodoncia con experiencia en brackets metálicos y estéticos, alineadores transparentes, ortopedia maxilar y casos que requieren microimplantes o extracciones coordinadas.',
        },
        s2: {
          title: 'Filosofía de atención',
          p1: 'Explico cada diagnóstico sin tecnicismos innecesarios. Creo que un paciente informado coopera mejor y obtiene resultados más estables a largo plazo.',
        },
        s3: {
          title: 'Smile Up',
          p1: 'Mi consulta está en Av. La Cultura 822, Wanchaq, Cusco. Atiendo de lunes a viernes y sábados por la mañana, en español e inglés para residentes y viajeros.',
        },
      },
      {
        b1: 'Especialista en ortodoncia',
        b2: 'Provider Invisalign',
        b3: 'Diagnóstico claro y honesto',
        b4: 'Consulta en el corazón de Cusco',
      },
      {
        heroImageAlt:
          'Dr. Germán Paniura realizando un procedimiento ortodóncico en su consulta en Cusco',
      }
    ),
    drApproach: page(
      'Filosofía de tratamiento ortodóncico | Dr. Paniura Cusco',
      'Filosofía de tratamiento del Dr. Paniura en Cusco: diagnóstico transparente, plan por etapas y seguimiento cercano en brackets y alineadores.',
      'Filosofía de tratamiento ortodóncico',
      'Creo que la ortodoncia exitosa empieza con un diagnóstico que el paciente entiende. Cada plan que diseño incluye objetivos, alternativas, tiempos estimados y cuidados diarios explicados de forma sencilla.',
      {
        s1: {
          title: 'Diagnóstico sin sorpresas',
          p1: 'Uso fotografías, modelos y radiografías para documentar el caso inicial. Antes de iniciar, reviso contigo las opciones: brackets metálicos, estéticos o alineadores.',
        },
        s2: {
          title: 'Plan por etapas',
          p1: 'Los tratamientos largos los divido en fases comprensibles: alineación, corrección de mordida, detalle final y retención. Sabrás qué esperar en cada visita.',
        },
        s3: {
          title: 'Seguimiento y adaptación',
          p1: 'Si cambian tus circunstancias —viaje, trabajo, sensibilidad— ajusto citas y recomendaciones sin perder el hilo del tratamiento.',
        },
      },
      {
        b1: 'Comunicación clara en cada visita',
        b2: 'Alternativas explicadas con pros y contras',
        b3: 'Flexibilidad para pacientes internacionales',
        b4: 'Enfoque en estabilidad a largo plazo',
      },
      {
        heroImageAlt:
          'Paciente con brackets estéticos sonriendo durante su tratamiento de ortodoncia en Cusco',
        heading: 'Así es tu tratamiento, paso a paso',
        steps: {
          v1: {
            title: 'Primera consulta',
            text: 'Escucho tu motivo de visita, revisamos antecedentes y aclaramos expectativas. Es el momento de resolver dudas antes de cualquier procedimiento.',
            alt: 'Primera consulta ortodóncica en Smile Up en Cusco',
          },
          v2: {
            title: 'Evaluación clínica',
            text: 'Examino mordida, alineación dental y tejidos de soporte. Documento el caso para que entiendas el punto de partida de tu tratamiento.',
            alt: 'Evaluación clínica ortodóncica',
          },
          v3: {
            title: 'Moldes y radiografías',
            text: 'Tomo fotografías, modelos de estudio y radiografías necesarias. Con estos registros preparo un diagnóstico preciso y sin sorpresas.',
            alt: 'Toma de moldes y radiografías para ortodoncia',
          },
          v4: {
            title: 'Plan por etapas',
            text: 'Te explico objetivos, alternativas (brackets metálicos, estéticos o alineadores), tiempos estimados y cuidados. Cada fase tiene un propósito claro.',
            alt: 'Plan de tratamiento de ortodoncia personalizado',
          },
        },
      }
    ),
    drInvisalign: page(
      'Provider Invisalign Cusco | Dr. Germán Paniura | Smile Up',
      'Invisalign en Cusco con el Dr. Germán Paniura, provider certificado. Alineadores transparentes con plan digital y seguimiento en Smile Up.',
      'Provider Invisalign en Cusco',
      'Como provider Invisalign, utilizo escaneo intraoral y planificación digital para proyectar movimientos dentales antes de fabricar los alineadores. Ideal para quienes buscan ortodoncia discreta en Cusco.',
      {
        s1: {
          title: 'Proceso con alineadores Invisalign',
          p1: 'Tras la evaluación, diseño una secuencia de alineadores personalizados. Cada juego mueve los dientes de forma controlada; en las revisiones confirmo que el avance coincide con el plan.',
        },
        s2: {
          title: 'Candidatos ideales',
          p1: 'Apiñamiento leve-moderado, diastemas y algunas correcciones de mordida pueden tratarse con alineadores. En casos complejos combino Invisalign con auxiliares como attachments o microimplantes.',
        },
        s3: {
          title: 'Ventaja para visitantes',
          p1: 'Puedo entregar varias series y programar controles según tu calendario de viaje, siempre que mantengas el uso diario recomendado.',
        },
      },
      {
        b1: 'Certificación Invisalign',
        b2: 'Simulación digital previa',
        b3: 'Tratamiento estético y removible',
        b4: 'Seguimiento personalizado',
      },
      {
        heroImageAlt:
          'Dr. Germán Paniura como provider certificado Invisalign en Cusco',
      }
    ),
    whySmileUp: page(
      'Ortodoncia en Cusco | ¿Por qué Smile Up? | Brackets y alineadores',
      'Ortodoncia en Cusco con el Dr. Paniura: brackets, alineadores, ortopedia maxilar y retenedores. Consulta en Av. La Cultura 822. Evaluación para locales y extranjeros.',
      'Ortodoncia en Cusco con el Dr. Paniura',
      'En mi consulta concentro los tratamientos de ortodoncia en un solo lugar: brackets metálicos y estéticos, Invisalign, ortopedia maxilar, microimplantes y retención. Pacientes de Cusco y visitantes encuentran aquí un plan claro y acompañamiento continuo.',
      {
        s1: {
          title: 'Especialización en ortodoncia',
          p1: 'Mi enfoque no se dispersa en múltiples especialidades generales: la ortodoncia es el centro de mi práctica, lo que me permite experiencia acumulada en casos variados.',
        },
        s2: {
          title: 'Ubicación y acceso',
          p1: 'Mi consulta está en Av. La Cultura 822, Wanchaq, zona accesible desde el centro de Cusco. Atiendo de mañana y tarde de lunes a viernes, y sábados por la mañana.',
        },
        s3: {
          title: 'Reserva en línea',
          p1: 'Puedes agendar tu evaluación desde el calendario web sin complicaciones. Confirmo tu cita y te indico qué traer a la primera visita.',
        },
      },
      {
        b1: 'Tratamientos de ortodoncia integrados',
        b2: 'Dr. Germán Paniura al frente',
        b3: 'Reservas online disponibles',
        b4: 'Atención bilingüe ES/EN',
      },
      {
        heroImageAlt:
          'Dr. Germán Paniura realizando un procedimiento ortodóncico en Smile Up, Cusco',
      }
    ),
    whyInternational: page(
      'Ortodoncia Cusco | Pacientes nacionales e internacionales | Niños y adultos',
      'Ortodoncia en Cusco para pacientes nacionales e internacionales. Brackets, alineadores Invisalign y tecnología digital para niños, jóvenes y adultos con el Dr. Paniura, Av. La Cultura 822.',
      'Ortodoncia en Cusco para pacientes nacionales e internacionales',
      'En Smile Up en Cusco atiendo a pacientes de todo el Perú y del extranjero: familias locales, viajeros y expatriados. Ofrezco ortodoncia para niños, adolescentes y adultos con brackets metálicos, brackets estéticos y alineadores transparentes, apoyado en tecnología de última generación para un diagnóstico preciso y un plan claro desde la primera consulta.',
      {
        s1: {
          title: 'Ortodoncia para niños, jóvenes y adultos',
          p1: 'Cada edad tiene necesidades distintas. En niños evalúo ortopedia maxilar y el momento ideal para iniciar; en adolescentes y adultos trabajo brackets o alineadores según estética, complejidad y estilo de vida. Pacientes nacionales de Lima, Arequipa o otras regiones y visitantes internacionales reciben el mismo estándar de atención especializada.',
          p2: 'Te explico tiempos, etapas y cuidados en lenguaje sencillo, para que decidas con confianza — seas residente en Cusco o estés de paso por la ciudad.',
        },
        s2: {
          title: 'Alineadores y tecnología de última generación',
          p1: 'Uso escaneo intraoral digital, planificación 3D y simulación del resultado antes de iniciar — especialmente con alineadores Invisalign. Esto reduce moldes incómodos, acelera el diagnóstico y te permite visualizar cómo evolucionará tu sonrisa.',
          p2: 'La tecnología no reemplaza el criterio clínico: la combino con seguimiento cercano en cada control, ya sea con alineadores, brackets metálicos o cerámicos.',
        },
        s3: {
          title: 'Atención para Perú y el extranjero',
          p1: 'Atiendo en español e inglés. Para pacientes internacionales coordino evaluaciones, entregas de alineadores y controles según tu calendario de viaje; para pacientes nacionales facilito continuidad y citas compatibles con trabajo o estudios.',
          p2: 'Mi consulta está en Av. La Cultura 822, Wanchaq — accesible desde el centro de Cusco y zonas habituales para visitantes. Reservas online y confirmación por WhatsApp. Si necesitas un dentista de emergencia en Cusco durante el viaje — dolor de muela, diente roto o inflamación — también ofrecemos atención urgente el mismo día, en inglés y español.',
        },
      },
      {
        b1: 'Ortodoncia infantil, adolescente y adulta',
        b2: 'Alineadores Invisalign y brackets estéticos',
        b3: 'Escaneo digital y planificación 3D',
        b4: 'Atención bilingüe: Perú y extranjero',
      },
      {
        heroImageAlt:
          'Ortodoncia en Cusco para pacientes nacionales e internacionales, niños y adultos en Smile Up',
      }
    ),
    whyComfort: page(
      'Comodidad y tecnología en ortodoncia Cusco | Smile Up',
      'Ortodoncia cómoda en Cusco: tecnología digital, explicaciones claras y ambiente acogedor. Tratamientos modernos con enfoque humano del Dr. Paniura.',
      'Comodidad y tecnología en ortodoncia',
      'Un buen tratamiento ortodóncico no solo mueve dientes: debe ser comprensible y llevadero. Uso herramientas digitales cuando aportan precisión y priorizo tu comodidad en cada visita a mi consulta en Cusco.',
      {
        s1: {
          title: 'Planificación digital',
          p1: 'Los escaneos y simulaciones —especialmente con alineadores— permiten visualizar el resultado esperado antes de iniciar. Esto reduce incertidumbre y mejora la adherencia al tratamiento.',
        },
        s2: {
          title: 'Ambiente y tiempos de cita',
          p1: 'Respeto tu horario: citas puntuales, explicaciones sin apuros y espacio para preguntas. Sé que muchos pacientes combinan tratamiento con trabajo o turismo.',
        },
        s3: {
          title: 'Educación continua',
          p1: 'Te enseño higiene con brackets, uso de elásticos, cuidado de alineadores y señales de alerta. Un paciente informado tiene menos urgencias y mejor resultado.',
        },
      },
      {
        b1: 'Simulación digital con alineadores',
        b2: 'Consultas organizadas y claras',
        b3: 'Material educativo en cada fase',
        b4: 'Enfoque en experiencia del paciente',
      }
    ),
    whyEvaluation: page(
      'Evaluación ortodóncica en Cusco | Primera consulta | Smile Up',
      'Evaluación ortodóncica personalizada en Cusco. Diagnóstico, radiografías y plan con brackets o alineadores. Reserva con el Dr. Paniura.',
      'Evaluación ortodóncica personalizada',
      'La primera consulta define el rumbo de tu tratamiento. Reviso mordida, alineación, hábitos y expectativas para proponerte un plan realista con tiempos, opciones y cuidados desde el día uno.',
      {
        s1: {
          title: 'Qué incluye la evaluación',
          p1: 'Examen clínico, fotografías, modelos o escaneo y radiografías según necesidad. Con esa información te explico si necesitas brackets, alineadores u ortopedia maxilar.',
        },
        s2: {
          title: 'Presupuesto y calendario',
          p1: 'Recibes una estimación de duración, frecuencia de controles e inversión por fase. Sin sorpresas: priorizo transparencia antes de iniciar cualquier procedimiento.',
        },
        s3: {
          title: 'Reserva tu cita',
          p1: 'Agenda en línea en minutos. Si vienes de fuera de Cusco, indica tus fechas para que yo pueda optimizar la planificación.',
        },
      },
      {
        b1: 'Diagnóstico completo en una visita',
        b2: 'Opciones comparadas claramente',
        b3: 'Estimación de tiempos realistas',
        b4: 'Reserva online disponible',
      }
    ),
    bookConsult: page(
      'Reservar consulta ortodoncia Cusco | Agenda online | Smile Up',
      'Reserva tu consulta de ortodoncia en Cusco online. Calendario disponible para evaluación con brackets, alineadores u ortopedia maxilar con el Dr. Paniura.',
      'Reserva tu consulta de ortodoncia',
      'Agendar tu evaluación ortodóncica en Cusco es rápido: elige día y hora en el calendario en línea. Confirmo tu cita y te indico cómo llegar a Av. La Cultura 822.',
      {
        s1: {
          title: 'Cómo reservar',
          p1: 'Entra al panel de reservas, selecciona fecha y horario disponible, completa tus datos de contacto y recibe confirmación. También puedes llamar al (084) 607 539 si prefieres asistencia telefónica.',
        },
        s2: {
          title: 'Qué esperar en la visita',
          p1: 'La primera cita incluye evaluación clínica y conversación sobre tus objetivos. Si se requieren radiografías, te lo indico con anticipación.',
        },
        s3: {
          title: 'Sin costo de reserva online',
          p1: 'Reservar en la web no tiene cargo adicional. Solo pagas la consulta o estudios acordados el día de tu cita.',
        },
      },
      {
        b1: 'Calendario en tiempo real',
        b2: 'Confirmación inmediata',
        b3: 'Ubicación en Wanchaq, Cusco',
        b4: 'Atención ES/EN',
      },
      {
        heroImageAlt:
          'Ilustración de calendario para reservar consulta de ortodoncia en Cusco',
      }
    ),
    firstAppt: page(
      'Primera cita ortodoncia Cusco | Qué esperar | Smile Up',
      'Tu primera cita de ortodoncia en Cusco: examen, fotos, radiografías y plan personalizado. Preparate con esta guía del Dr. Paniura.',
      'Primera cita de ortodoncia en Cusco',
      'La primera visita ortodóncica es el momento de conocer tu caso en profundidad. Te explico qué revisaré, cuánto dura la cita y qué documentos o hábitos conviene que me menciones.',
      {
        s1: {
          title: 'Duración y desarrollo',
          p1: 'Suele durar entre 45 y 60 minutos. Incluye examen intraoral y extraoral, registro fotográfico y, si corresponde, radiografías o escaneo digital.',
        },
        s2: {
          title: 'Qué llevar',
          p1: 'Radiografías previas si las tienes, lista de medicamentos y preguntas sobre estética, tiempos o presupuesto. Para niños, acompañamiento de un adulto responsable.',
        },
        s3: {
          title: 'Después de la consulta',
          p1: 'Recibes recomendaciones claras: iniciar de inmediato, esperar una fase de crecimiento o derivación complementaria. Si decides avanzar, programo la cita de inicio del tratamiento.',
        },
      },
      {
        b1: 'Guía clara para nuevos pacientes',
        b2: 'Tiempo suficiente para preguntas',
        b3: 'Plan escrito con opciones',
        b4: 'Ideal para locales y viajeros',
      },
      {
        heroImageAlt:
          'Jóvenes sonriendo con dientes alineados, representando pacientes felices tras ortodoncia en Cusco',
      }
    ),
    location: page(
      'Ubicación clínica ortodoncia Cusco | Av. La Cultura 822 | Smile Up',
      'Consulta de ortodoncia en Cusco, Av. La Cultura 822, Wanchaq. Horarios, mapa y cómo llegar. Brackets y alineadores cerca del centro con el Dr. Paniura.',
      'Ubicación y Horarios en Cusco',
      'Mi consulta de ortodoncia está en Av. La Cultura 822, distrito de Wanchaq, Cusco. Fácil acceso al costado del Instituto de Francés "Alianza Francesa" y a pocos minutos del centro histórico. Atiendo de lunes a viernes y sábados por la mañana.',
      {
        s1: {
          title: 'Dirección y referencias',
          p1: 'Av. La Cultura 822, Wanchaq, Cusco, Perú. A pocos minutos en taxi desde la Plaza de Armas. Puedes solicitar ubicación exacta por WhatsApp al reservar tu cita.',
        },
        s2: {
          title: 'Horario de atención',
          p1: 'Lunes a viernes de 9:00 a 19:00 y sábados de 9:00 a 13:00. Citas fuera de horario solo con coordinación previa conmigo.',
        },
        s3: {
          title: 'Contacto',
          p1: 'Teléfono: (084) 607 539. Reservas online disponibles las 24 horas. Atiendo en español e inglés para pacientes locales e internacionales.',
        },
      },
      {
        b1: 'Zona céntrica de Cusco',
        b2: 'Horario extendido entre semana',
        b3: 'Sábados por la mañana',
        b4: 'Reserva y WhatsApp disponibles',
      }
    ),
    firstConsult: page(
      'Primera consulta ortodóncica Cusco | Guía Smile Up',
      'Guía de la primera consulta ortodóncica en Cusco: evaluación, opciones de brackets y alineadores, tiempos y reserva online con el Dr. Paniura.',
      'Primera consulta ortodóncica en Cusco',
      'Esta guía resume qué ocurre en tu evaluación inicial: desde el registro clínico hasta mi propuesta de tratamiento con brackets, alineadores u ortopedia maxilar. Ideal si es tu primer acercamiento a la ortodoncia en Cusco.',
      {
        s1: {
          title: 'Objetivo de la consulta',
          p1: 'Determino si necesitas ortodoncia activa, en qué fase iniciar y qué técnica se adapta mejor a tu estilo de vida y presupuesto.',
        },
        s2: {
          title: 'Preguntas frecuentes',
          p1: '¿Duele? Los inicios pueden generar presión leve unos días. ¿Edad límite? Hay tratamientos para niños, adolescentes y adultos. ¿Cuánto cuesta? Depende del caso; lo reviso en la evaluación con detalle.',
        },
        s3: {
          title: 'Reserva ahora',
          p1: 'Usa el calendario online para elegir tu horario. Si leíste mi guía de alineadores en el blog, trae tus dudas: las resuelvo en persona con tu diagnóstico real.',
        },
      },
      {
        b1: 'Contenido educativo previo a la cita',
        b2: 'Resolución de dudas frecuentes',
        b3: 'Enlace directo a reservas',
        b4: 'Complemento al blog de ortodoncia',
      }
    ),
  },
};

export const orthoPagesEn = {
  common: {
    bookCta: 'Book your orthodontic evaluation',
    backHome: 'Back to home',
    trust1: 'Dr. Germán Paniura · Orthodontist',
    trust2: 'Braces and aligners in Cusco',
    trust3: 'Local and international care',
    benefitsTitle: 'Why trust my practice',
    ctaTitle: 'Ready for your evaluation?',
    ctaText:
      'Book your first appointment online. I explain options, realistic timelines and daily care from day one — without unnecessary jargon.',
  },
  pages: {
    metalBraces: page(
      'Metal Braces in Cusco | Fixed Orthodontics | Smile Up',
      'Metal braces in Cusco: effective fixed orthodontics for children, teens and adults. Evaluation, treatment plan and follow-up with Dr. Paniura, Av. La Cultura 822.',
      'Metal braces in Cusco',
      'Metal braces remain one of the most reliable options to correct crowding, crossbite and spacing. In my practice in Cusco I plan your treatment with regular adjustments and explain each step clearly at every visit.',
      {
        s1: {
          title: 'When do I recommend metal braces?',
          p1: 'They are ideal when precise control of each tooth is needed, especially in moderate or complex cases. They are often the most accessible fixed orthodontic option in Cusco.',
          p2: 'During evaluation I review X-rays, photos and models to decide whether metal braces are the best choice versus ceramic braces or aligners.',
        },
        s2: {
          title: 'Treatment at my practice',
          p1: 'The process includes initial placement, adjustments every 4–6 weeks and coaching on braces hygiene. I adapt the plan if you travel or live outside Cusco, coordinating visits when possible.',
        },
        s3: {
          title: 'Duration and results',
          p1: 'Timing depends on case complexity; many treatments last 18–24 months. My goal is an aligned smile and functional bite, with retainers at the end.',
        },
      },
      {
        b1: 'Detailed control of tooth movement',
        b2: 'Strong option for complex cases',
        b3: 'Close follow-up with Dr. Paniura',
        b4: 'Care in Spanish and English',
      },
      {
        heroImageAlt: 'Teen smiling and showing metal braces during orthodontic treatment',
      }
    ),
    ceramicBraces: page(
      'Ceramic Braces in Cusco | Aesthetic Brackets | Smile Up',
      'Ceramic or aesthetic braces in Cusco: discreet fixed orthodontics with the same efficiency as metal braces. Consultation with Dr. Paniura for teens and adults.',
      'Ceramic braces in Cusco',
      'Ceramic braces combine the precision of fixed orthodontics with a more discreet look. In Cusco, many adult patients and professionals choose this option to straighten their smile without sacrificing aesthetics during treatment.',
      {
        s1: {
          title: 'Ceramic vs metal braces',
          p1: 'Aesthetic brackets work like metal ones but blend with tooth color. They are an excellent alternative when professional or personal image matters during treatment.',
        },
        s2: {
          title: 'Care and recommendations',
          p1: 'They require the same rigorous hygiene as metal braces and avoiding very hard or staining foods on ligatures. At each check-up I review bracket condition and adjust the wire.',
        },
        s3: {
          title: 'Personalized evaluation in Cusco',
          p1: 'Not every case needs the same technique. At the first visit I compare aesthetic braces, metal braces and Invisalign based on your goals, timeline and budget.',
        },
      },
      {
        b1: 'More natural look during treatment',
        b2: 'Same efficiency as metal braces',
        b3: 'Ideal for adults in Cusco',
        b4: 'Clear plan from the first visit',
      },
      {
        heroImageAlt:
          'Patient with aesthetic ceramic braces during orthodontic treatment in Cusco',
      }
    ),
    invisalign: page(
      'Invisalign in Cusco | Clear Aligners | Smile Up',
      'Invisalign and clear aligners in Cusco. Removable, comfortable, discreet orthodontics with Dr. Germán Paniura. Book your evaluation at Smile Up.',
      'Invisalign and clear aligners in Cusco',
      'Clear aligners straighten teeth without visible brackets. In my practice in Cusco I offer aligner treatment — including Invisalign when indicated — with scans, digital planning and scheduled check-ups.',
      {
        s1: {
          title: 'Who are aligners for?',
          p1: 'They work well for mild to moderate crowding, spacing and some bite corrections. At evaluation I confirm whether your case fits aligners or if fixed braces are better.',
        },
        s2: {
          title: 'Benefits of removable aligners',
          p1: 'You remove them to eat and brush, which simplifies hygiene. They are discreet in photos and meetings — helpful for international patients visiting Cusco or living temporarily in the city.',
        },
        s3: {
          title: 'Commitment and follow-up',
          p1: 'Success depends on wearing aligners 20–22 hours daily. I schedule reviews to deliver new sets and verify movement matches the digital plan.',
        },
      },
      {
        b1: 'Discreet, removable treatment',
        b2: 'Invisalign provider in Cusco',
        b3: 'Digital treatment planning',
        b4: 'Suitable for travelers with planned follow-up',
      },
      {
        heroImageAlt:
          'Patient wearing clear Invisalign aligners during orthodontic treatment in Cusco',
      }
    ),
    selfLigatingBraces: page(
      'Self-Ligating Braces in Cusco | Fixed Orthodontics | Smile Up',
      'Self-ligating braces in Cusco: fixed orthodontics with less friction and more comfortable check-ups. Evaluation and treatment plan with Dr. Paniura, Av. La Cultura 822.',
      'Self-ligating braces in Cusco',
      'Self-ligating brackets use an integrated clip system that reduces friction between the wire and the bracket. In my practice in Cusco I recommend them when you want effective fixed orthodontics with more comfortable visits and, in many cases, longer intervals between appointments.',
      {
        s1: {
          title: 'How do they differ from conventional braces?',
          p1: 'Unlike metal or ceramic braces with elastic ligatures, self-ligating brackets hold the wire with their own closing mechanism. That can mean less initial pressure and gentler tooth movement in selected stages of treatment.',
          p2: 'They do not replace professional diagnosis or follow-up: at evaluation I confirm whether your case benefits from self-ligating braces versus other fixed options or aligners.',
        },
        s2: {
          title: 'Benefits I explain in consultation',
          p1: 'Many patients report greater comfort after adjustments and somewhat easier hygiene without ligatures that trap plaque. I also value their usefulness in moderate crowding and for adults who want fixed orthodontics with predictable check-ups.',
        },
        s3: {
          title: 'Treatment and follow-up in Cusco',
          p1: 'The plan includes placement, periodic activations and guidance on brace care. If you live outside Cusco or travel, we coordinate visits so you keep steady progress in your treatment.',
        },
      },
      {
        b1: 'Fixed orthodontics with integrated clip system',
        b2: 'Comfortable check-ups and personalized plan',
        b3: 'Close follow-up with Dr. Paniura',
        b4: 'Care in Spanish and English',
      },
      {
        heroImageAlt:
          'Self-ligating braces during orthodontic treatment in Cusco',
      }
    ),
    klamm: page(
      'Klammt Appliance | Maxillary Orthopedics | Smile Up',
      'Klammt appliance for pediatric maxillary orthopedics. Guides growth and corrects habits in children and teens with Dr. Paniura.',
      'Klammt appliance',
      'The Klammt appliance is a removable functional plate that uses growth to guide the maxilla and mandible. In my practice I indicate it in selected maxillary orthopedics cases, always after a full clinical and radiographic evaluation.',
      {
        s1: {
          title: 'What is the Klammt appliance?',
          p1: 'It is an orthopedic device that combines skeletal guidance and muscle re-education. Its design allows intervention during active growth, when the jaws can still be modified more conservatively.',
        },
        s2: {
          title: 'Indications in children and teens',
          p1: 'It may be indicated for mild to moderate Class II bites, habits such as mouth breathing or tongue thrust, and certain developing asymmetries. I assess age, patient cooperation and family goals before recommending it.',
        },
        s3: {
          title: 'Wear, check-ups and next phases',
          p1: 'I explain daily wear time, appliance hygiene and warning signs between visits. Klammt may be part of a staged plan that continues with full orthodontics if needed.',
        },
      },
      {
        b1: 'Interception during growth',
        b2: 'Age-tailored plan',
        b3: 'Follow-up with Dr. Paniura',
        b4: 'Practice at Av. La Cultura 822',
      },
      {
        heroImageAlt: 'Klammt maxillary orthopedics appliance for treatment',
      }
    ),
    bimler: page(
      'Bimler Appliance | Functional Orthopedics | Smile Up',
      'Bimler technique: functional appliances to correct habits and harmonize jaws in children and teens. Evaluation with Dr. Paniura.',
      'Bimler appliance',
      'The Bimler technique uses functional appliances that stimulate correct muscle patterns while guiding maxillomandibular development. I apply it when diagnosis indicates functional re-education combined with growth control.',
      {
        s1: {
          title: 'Basis of the Bimler technique',
          p1: 'It balances muscle forces — tongue, lips and facial muscles — to favor a more harmonious maxillomandibular relationship during growth.',
        },
        s2: {
          title: 'When do I recommend it?',
          p1: 'In growing patients with functional alterations, developing Class II bite or habits that interfere with occlusion. Child cooperation and family commitment are key to success.',
        },
        s3: {
          title: 'Check-ups and treatment evolution',
          p1: 'I schedule periodic reviews to adjust the appliance and verify progress. If dental misalignment persists after the functional phase, I plan braces or aligners.',
        },
      },
      {
        b1: 'Functional and muscular focus',
        b2: 'Indicated during active growth',
        b3: 'Clear explanation for parents',
        b4: 'Care in Spanish and English',
      },
      {
        heroImageAlt: 'Bimler maxillary orthopedics appliance at orthodontic consultation',
      }
    ),
    planas: page(
      'Planas Plates | Interceptive Orthopedics | Smile Up',
      'Planas plates for interceptive maxillary orthopedics in children. Corrects habits and prepares dentition with Dr. Paniura, Av. La Cultura 822.',
      'Planas plates',
      'Planas plates are active devices combining support and activation elements to modify habits and tooth position in childhood. In my practice I indicate them as part of personalized interceptive treatment.',
      {
        s1: {
          title: 'What are Planas plates?',
          p1: 'They are removable appliances with screws or active elements allowing small dental corrections and oral function re-education, using growth-period flexibility.',
        },
        s2: {
          title: 'Problems they may address',
          p1: 'Mild crowding, incipient open bite, prolonged sucking habits and mild functional deviations. Early evaluation defines whether a Planas plate is enough or another appliance is better.',
        },
        s3: {
          title: 'Care and follow-up',
          p1: 'I indicate wear time, appliance cleaning and reviews to activate or adjust the plate. The goal is to simplify future treatment and stabilize more favorable maxillofacial development.',
        },
      },
      {
        b1: 'Active interceptive treatment',
        b2: 'Custom removable appliances',
        b3: 'Pediatric orthodontic evaluation',
        b4: 'Practice at Av. La Cultura 822, Wanchaq',
      },
      {
        heroImageAlt: 'Planas maxillary orthopedics plates for children',
      }
    ),
    stockfisch: page(
      'Stockfisch Appliance | Maxillary Orthopedics | Smile Up',
      'Stockfisch appliance: functional orthopedics to harmonize growing jaws. Evaluation and plan with Dr. Paniura.',
      'Stockfisch appliance',
      'The Stockfisch appliance is a functional device that helps balance maxillomandibular development in growing patients. I use it within maxillary orthopedics plans when skeletal and functional pattern justify it.',
      {
        s1: {
          title: 'Features of the Stockfisch appliance',
          p1: 'Designed to influence the relationship between upper and lower jaw through functional guidance, favoring more stable bite positions during development.',
        },
        s2: {
          title: 'Common indications',
          p1: 'Mild to moderate skeletal discrepancies in growth, airway-related alterations linked to mandibular posture and cases requiring arch preparation before fixed orthodontics.',
        },
        s3: {
          title: 'Staged plan',
          p1: 'I explain estimated duration, daily wear and goals per phase. After completing functional orthopedics, I assess whether the patient needs braces, aligners or retention only.',
        },
      },
      {
        b1: 'Maxillomandibular harmonization',
        b2: 'Uses growth stages',
        b3: 'Diagnosis based on full exam',
        b4: 'Close follow-up with Dr. Paniura',
      },
      {
        heroImageAlt: 'Stockfisch maxillary orthopedics appliance in treatment',
      }
    ),
    clarkTwinBlock: page(
      'Clark Twin Block | Class II Functional Orthopedics | Smile Up',
      'Clark Twin Block to correct Class II during growth. Twin blocks and functional orthopedics with Dr. Paniura, Av. La Cultura 822.',
      'Clark Twin Block',
      'The Clark Twin Block is a widely used twin-block functional appliance to advance the mandible in growing Class II patients. In my practice I indicate it when diagnosis and patient age are compatible with this therapy.',
      {
        s1: {
          title: 'How does the Twin Block work?',
          p1: 'It consists of two plates — upper and lower — with ramps that guide the mandible forward when closing, stimulating skeletal and muscular adaptation.',
        },
        s2: {
          title: 'Who is it for?',
          p1: 'Mainly children and teens at peak growth with skeletal or functional Class II. I assess bone maturity, available space and cooperation before starting.',
        },
        s3: {
          title: 'Duration and next phase',
          p1: 'Treatment usually lasts several months with near full-time wear. After stabilizing improvement, I may indicate retention, transition plates or start braces or aligners.',
        },
      },
      {
        b1: 'Reference in Class II orthopedics',
        b2: 'Proven appliance during growth',
        b3: 'Clear plan for parents and patients',
        b4: 'Evaluation at Smile Up',
      },
      {
        heroImageAlt: 'Clark Twin Block maxillary orthopedics appliance',
      }
    ),
    retainers: page(
      'Retainers in Cusco | Maintain Your Smile | Smile Up',
      'Fixed and removable retainers in Cusco after braces or aligners. Prevent relapse and keep your new smile. Retention with Dr. Paniura, Cusco.',
      'Orthodontic retainers in Cusco',
      'Finishing braces or aligners is not the end: retainers hold teeth in their new position while bone and gums stabilize. In my practice I indicate the retention type based on your case.',
      {
        s1: {
          title: 'Types of retainers',
          p1: 'Removable retainers (such as clear night trays) and fixed retainers (wire behind incisors) play complementary roles. I choose the combination that best protects your result.',
        },
        s2: {
          title: 'Wear time and check-ups',
          p1: 'Initially worn almost full-time; later transitions to long-term nightly use. Reviews allow adjustment or replacement if a retainer is lost or deformed.',
        },
        s3: {
          title: 'Cusco residents and visitors',
          p1: 'If you completed treatment elsewhere, I can make or review retainers during your stay in Cusco. Bring models or X-rays if available.',
        },
      },
      {
        b1: 'Protection against relapse',
        b2: 'Fixed and removable options',
        b3: 'Clear wear instructions',
        b4: 'Post-treatment follow-up',
      },
      {
        heroImageAlt:
          'Removable Hawley orthodontic retainer on a dental model for post-treatment retention',
      }
    ),
    miniImplants: page(
      'Orthodontic Mini-Implants Cusco | TAD Anchorage | Smile Up',
      'Orthodontic mini-implants (TADs) in Cusco for complex tooth movements. Temporary anchorage within braces or aligner plans with Dr. Paniura.',
      'Orthodontic mini-implants in Cusco',
      'Mini-implants — temporary anchorage screws — help move difficult teeth without relying on other teeth for support. The specialist indicates them in selected cases within comprehensive orthodontic plans in Cusco.',
      {
        s1: {
          title: 'When are they indicated?',
          p1: 'Useful to close spaces, intrude molars, correct open bites or move an anchored tooth without affecting the rest of the arch. I make the decision after radiographic study and case analysis.',
        },
        s2: {
          title: 'Placement and discomfort',
          p1: 'Installation is outpatient under local anesthesia. Most patients report mild pressure for a few days. I remove the mini-implant once it has served its purpose — no permanent implant remains.',
        },
        s3: {
          title: 'Integration with your treatment',
          p1: 'They are part of the overall plan with braces or aligners. I explain why they are needed, how long they stay and how to care for the area.',
        },
      },
      {
        b1: 'Greater control in complex cases',
        b2: 'Minimally invasive procedure',
        b3: 'Removed after serving its function',
        b4: 'Plan coordinated by the specialist',
      },
      {
        heroImageAlt:
          'Orthodontic temporary anchorage device (TAD) mini-implant for complex treatments in Cusco',
      }
    ),
    thirdMolar: page(
      'Wisdom Tooth Surgery Cusco | Third Molar Extraction | Smile Up',
      'Third molar extraction in Cusco when your orthodontic plan requires it. Wisdom tooth surgery coordinated with active treatment by Dr. Paniura.',
      'Third molar surgery in Cusco',
      'Wisdom teeth can interfere with alignment or push already corrected teeth. When the orthodontic plan indicates, I coordinate third molar extraction with clear postoperative care.',
      {
        s1: {
          title: 'Relation to orthodontics',
          p1: 'Sometimes extraction is best before closing spaces; other times at the end of treatment. I assess position, available space and impaction with panoramic X-ray.',
        },
        s2: {
          title: 'Procedure and recovery',
          p1: 'I perform surgery under local anesthesia with aseptic protocols. I provide pain management, soft diet and hygiene instructions. Most return to light activities within a few days.',
        },
        s3: {
          title: 'Travelers in Cusco',
          p1: 'If you are passing through, I schedule extraction with recovery margin before your flight or bus. I prioritize your safety and communicate realistic timelines.',
        },
      },
      {
        b1: 'Decision based on X-ray',
        b2: 'Coordination with active orthodontics',
        b3: 'Clear postoperative instructions',
        b4: 'Care in Spanish and English',
      },
      {
        heroImageAlt:
          'Orthodontic evaluation and wisdom tooth surgery planning in Cusco',
      }
    ),
    drProfile: page(
      'Dr. Germán Paniura | Orthodontist in Cusco | Smile Up',
      'Meet Dr. Germán Paniura, orthodontist in Cusco. Specialist in braces, aligners and maxillary orthopedics at Smile Up, Av. La Cultura 822.',
      'Dr. Germán Paniura, orthodontist in Cusco',
      'I am Dr. Germán Paniura and I lead Smile Up in Cusco. My approach combines rigorous diagnosis, direct communication and treatment plans adapted to local and international patients.',
      {
        s1: {
          title: 'Training and experience',
          p1: 'I am an orthodontics specialist with experience in metal and aesthetic braces, clear aligners, maxillary orthopedics and cases requiring mini-implants or coordinated extractions.',
        },
        s2: {
          title: 'Care philosophy',
          p1: 'I explain each diagnosis without unnecessary jargon. I believe an informed patient cooperates better and achieves more stable long-term results.',
        },
        s3: {
          title: 'Smile Up',
          p1: 'My practice is at Av. La Cultura 822, Wanchaq, Cusco. I see patients Monday–Friday and Saturday mornings, in Spanish and English for residents and travelers.',
        },
      },
      {
        b1: 'Orthodontics specialist',
        b2: 'Invisalign provider',
        b3: 'Clear, honest diagnosis',
        b4: 'Practice in the heart of Cusco',
      },
      {
        heroImageAlt:
          'Dr. Germán Paniura performing an orthodontic procedure at his practice in Cusco',
      }
    ),
    drApproach: page(
      'Orthodontic Treatment Philosophy | Dr. Paniura Cusco',
      'Dr. Paniura\'s treatment philosophy in Cusco: transparent diagnosis, staged plans and close follow-up with braces and aligners.',
      'Orthodontic treatment philosophy',
      'I believe successful orthodontics starts with a diagnosis the patient understands. Every plan I design includes goals, alternatives, estimated timelines and daily care explained simply.',
      {
        s1: {
          title: 'Diagnosis without surprises',
          p1: 'I use photos, models and X-rays to document the initial case. Before starting, I review options with you: metal braces, aesthetic braces or aligners.',
        },
        s2: {
          title: 'Staged plan',
          p1: 'I divide long treatments into understandable phases: alignment, bite correction, finishing detail and retention. You will know what to expect at each visit.',
        },
        s3: {
          title: 'Follow-up and adaptation',
          p1: 'If circumstances change — travel, work, sensitivity — I adjust appointments and recommendations without losing treatment momentum.',
        },
      },
      {
        b1: 'Clear communication every visit',
        b2: 'Alternatives explained with pros and cons',
        b3: 'Flexibility for international patients',
        b4: 'Focus on long-term stability',
      },
      {
        heroImageAlt:
          'Patient with aesthetic braces smiling during orthodontic treatment in Cusco',
        heading: 'Your treatment, step by step',
        steps: {
          v1: {
            title: 'First consultation',
            text: 'I listen to your reason for visiting, review your history and clarify expectations. This is the time to answer questions before any procedure.',
            alt: 'First orthodontic consultation at Smile Up in Cusco',
          },
          v2: {
            title: 'Clinical evaluation',
            text: 'I examine bite, tooth alignment and supporting tissues. I document the case so you understand your starting point.',
            alt: 'Orthodontic clinical evaluation',
          },
          v3: {
            title: 'Models and X-rays',
            text: 'I take photos, study models and necessary X-rays. With these records I prepare an accurate diagnosis without surprises.',
            alt: 'Orthodontic impressions and X-rays',
          },
          v4: {
            title: 'Staged plan',
            text: 'I explain goals, alternatives (metal braces, aesthetic braces or aligners), estimated timelines and care. Each phase has a clear purpose.',
            alt: 'Personalized orthodontic treatment plan',
          },
        },
      }
    ),
    drInvisalign: page(
      'Invisalign Provider Cusco | Dr. Germán Paniura | Smile Up',
      'Invisalign in Cusco with Dr. Germán Paniura, certified provider. Clear aligners with digital planning and follow-up at Smile Up.',
      'Invisalign provider in Cusco',
      'As an Invisalign provider, I use intraoral scanning and digital planning to project tooth movements before aligners are manufactured. Ideal for those seeking discreet orthodontics in Cusco.',
      {
        s1: {
          title: 'Invisalign aligner process',
          p1: 'After evaluation, I design a personalized aligner sequence. Each set moves teeth in a controlled way; at reviews I confirm progress matches the plan.',
        },
        s2: {
          title: 'Ideal candidates',
          p1: 'Mild–moderate crowding, spacing and some bite corrections may be treated with aligners. In complex cases I combine Invisalign with attachments or mini-implants.',
        },
        s3: {
          title: 'Advantage for visitors',
          p1: 'I can deliver several sets and schedule check-ups according to your travel calendar, as long as daily wear recommendations are maintained.',
        },
      },
      {
        b1: 'Invisalign certification',
        b2: 'Prior digital simulation',
        b3: 'Aesthetic, removable treatment',
        b4: 'Personalized follow-up',
      },
      {
        heroImageAlt:
          'Dr. Germán Paniura as certified Invisalign provider in Cusco',
      }
    ),
    whySmileUp: page(
      'Orthodontics in Cusco | Why Smile Up? | Braces & Aligners',
      'Orthodontics in Cusco with Dr. Paniura: braces, aligners, maxillary orthopedics and retainers. Practice at Av. La Cultura 822. Evaluation for locals and foreigners.',
      'Orthodontics in Cusco with Dr. Paniura',
      'In my practice I concentrate orthodontic treatments in one place: metal and aesthetic braces, Invisalign, maxillary orthopedics, mini-implants and retention. Cusco patients and visitors find a clear plan and continuous support here.',
      {
        s1: {
          title: 'Orthodontics specialization',
          p1: 'My focus does not spread across many general specialties: orthodontics is the center of my practice, building experience across varied cases.',
        },
        s2: {
          title: 'Location and access',
          p1: 'My practice is at Av. La Cultura 822, Wanchaq, accessible from central Cusco. Morning and afternoon hours Monday–Friday, and Saturday mornings.',
        },
        s3: {
          title: 'Online booking',
          p1: 'You can schedule your evaluation from the web calendar easily. I confirm your appointment and tell you what to bring to the first visit.',
        },
      },
      {
        b1: 'Integrated orthodontic treatments',
        b2: 'Dr. Germán Paniura at the helm',
        b3: 'Online booking available',
        b4: 'Bilingual care ES/EN',
      },
      {
        heroImageAlt:
          'Dr. Germán Paniura performing an orthodontic procedure at Smile Up, Cusco',
      }
    ),
    whyInternational: page(
      'Orthodontics Cusco | National & International Patients | Children & Adults',
      'Orthodontics in Cusco for national and international patients. Braces, Invisalign aligners and digital technology for children, teens and adults with Dr. Paniura, Av. La Cultura 822.',
      'Orthodontics in Cusco for national and international patients',
      'At Smile Up in Cusco I treat patients from across Peru and abroad: local families, travelers and expats. I offer orthodontics for children, teens and adults with metal braces, aesthetic braces and clear aligners, supported by state-of-the-art technology for accurate diagnosis and a clear plan from the first consultation.',
      {
        s1: {
          title: 'Orthodontics for children, teens and adults',
          p1: 'Each age has different needs. In children I assess maxillary orthopedics and the ideal time to start; in teens and adults I work with braces or aligners based on aesthetics, complexity and lifestyle. National patients from Lima, Arequipa or other regions and international visitors receive the same specialist standard of care.',
          p2: 'I explain timelines, stages and care in plain language so you can decide with confidence — whether you live in Cusco or are passing through the city.',
        },
        s2: {
          title: 'Aligners and state-of-the-art technology',
          p1: 'I use digital intraoral scanning, 3D planning and outcome simulation before starting — especially with Invisalign aligners. This reduces uncomfortable impressions, speeds up diagnosis and lets you visualize how your smile will evolve.',
          p2: 'Technology does not replace clinical judgment: I combine it with close follow-up at every check-up, whether with aligners, metal or ceramic braces.',
        },
        s3: {
          title: 'Care for Peru and abroad',
          p1: 'I provide care in Spanish and English. For international patients I coordinate evaluations, aligner deliveries and check-ups around your travel schedule; for national patients I facilitate continuity and appointments compatible with work or studies.',
          p2: 'My practice is at Av. La Cultura 822, Wanchaq — accessible from downtown Cusco and areas common for visitors. Online booking and WhatsApp confirmation. If you need an emergency dentist in Cusco during your trip — toothache, broken tooth or swelling — we also provide same-day urgent dental care in English.',
        },
      },
      {
        b1: 'Child, teen and adult orthodontics',
        b2: 'Invisalign aligners and aesthetic braces',
        b3: 'Digital scanning and 3D planning',
        b4: 'Bilingual care: Peru and abroad',
      },
      {
        heroImageAlt:
          'Orthodontics in Cusco for national and international patients, children and adults at Smile Up',
      }
    ),
    whyComfort: page(
      'Comfort & Technology Orthodontics Cusco | Smile Up',
      'Comfortable orthodontics in Cusco: digital technology, clear explanations and a welcoming environment. Modern treatment with a human focus from Dr. Paniura.',
      'Comfort and technology in orthodontics',
      'Good orthodontic treatment does not only move teeth — it must be understandable and manageable. I use digital tools when they add precision and prioritize your comfort at every visit to my practice in Cusco.',
      {
        s1: {
          title: 'Digital planning',
          p1: 'Scans and simulations — especially with aligners — let you visualize expected results before starting. This reduces uncertainty and improves treatment adherence.',
        },
        s2: {
          title: 'Environment and appointment times',
          p1: 'I respect your schedule: punctual visits, unhurried explanations and room for questions. I know many patients combine treatment with work or tourism.',
        },
        s3: {
          title: 'Ongoing education',
          p1: 'I teach braces hygiene, elastic use, aligner care and warning signs. An informed patient has fewer emergencies and better outcomes.',
        },
      },
      {
        b1: 'Digital simulation with aligners',
        b2: 'Organized, clear consultations',
        b3: 'Educational material at each phase',
        b4: 'Patient experience focus',
      }
    ),
    whyEvaluation: page(
      'Orthodontic Evaluation Cusco | First Consultation | Smile Up',
      'Personalized orthodontic evaluation in Cusco. Diagnosis, X-rays and plan with braces or aligners. Book with Dr. Paniura.',
      'Personalized orthodontic evaluation',
      'The first consultation defines the direction of your treatment. I review bite, alignment, habits and expectations to propose a realistic plan with timelines, options and care from day one.',
      {
        s1: {
          title: 'What the evaluation includes',
          p1: 'Clinical exam, photos, models or scan and X-rays as needed. With that information I explain whether you need braces, aligners or maxillary orthopedics.',
        },
        s2: {
          title: 'Budget and calendar',
          p1: 'You receive duration estimate, check-up frequency and investment by phase. No surprises: I prioritize transparency before any procedure starts.',
        },
        s3: {
          title: 'Book your appointment',
          p1: 'Schedule online in minutes. If you are coming from outside Cusco, share your dates so I can optimize planning.',
        },
      },
      {
        b1: 'Complete diagnosis in one visit',
        b2: 'Options compared clearly',
        b3: 'Realistic timeline estimates',
        b4: 'Online booking available',
      }
    ),
    bookConsult: page(
      'Book Orthodontic Consultation Cusco | Online Scheduling | Smile Up',
      'Book your orthodontic consultation in Cusco online. Calendar available for evaluation with braces, aligners or maxillary orthopedics with Dr. Paniura.',
      'Book your orthodontic consultation',
      'Scheduling your orthodontic evaluation in Cusco is quick: choose day and time on the online calendar. I confirm your appointment and directions to Av. La Cultura 822.',
      {
        s1: {
          title: 'How to book',
          p1: 'Open the booking panel, select an available date and time, complete contact details and receive confirmation. You can also call (084) 607 539 for phone assistance.',
        },
        s2: {
          title: 'What to expect at the visit',
          p1: 'The first appointment includes clinical evaluation and discussion of your goals. If X-rays are needed, I tell you in advance.',
        },
        s3: {
          title: 'No online booking fee',
          p1: 'Web booking has no extra charge. You only pay for the consultation or studies agreed on appointment day.',
        },
      },
      {
        b1: 'Real-time calendar',
        b2: 'Immediate confirmation',
        b3: 'Location in Wanchaq, Cusco',
        b4: 'ES/EN care',
      },
      {
        heroImageAlt:
          'Calendar illustration for booking an orthodontic consultation in Cusco',
      }
    ),
    firstAppt: page(
      'First Orthodontic Appointment Cusco | What to Expect | Smile Up',
      'Your first orthodontic appointment in Cusco: exam, photos, X-rays and personalized plan. Prepare with this guide from Dr. Paniura.',
      'First orthodontic appointment in Cusco',
      'The first orthodontic visit is when I get to know your case in depth. I explain what I will review, how long the appointment lasts and what documents or habits you should mention.',
      {
        s1: {
          title: 'Duration and flow',
          p1: 'Usually 45–60 minutes. Includes intraoral and extraoral exam, photographic records and, when indicated, X-rays or digital scan.',
        },
        s2: {
          title: 'What to bring',
          p1: 'Previous X-rays if available, medication list and questions about aesthetics, timing or budget. For children, accompaniment by a responsible adult.',
        },
        s3: {
          title: 'After the consultation',
          p1: 'You receive clear recommendations: start immediately, wait for a growth phase or complementary referral. If you decide to proceed, I schedule treatment start.',
        },
      },
      {
        b1: 'Clear guide for new patients',
        b2: 'Enough time for questions',
        b3: 'Written plan with options',
        b4: 'Ideal for locals and travelers',
      },
      {
        heroImageAlt:
          'Young people smiling with aligned teeth, representing happy orthodontic patients in Cusco',
      }
    ),
    location: page(
      'Orthodontic Clinic Location Cusco | Av. La Cultura 822 | Smile Up',
      'Orthodontic practice in Cusco, Av. La Cultura 822, Wanchaq. Hours, map and directions. Braces and aligners near downtown with Dr. Paniura.',
      'Location and Hours in Cusco',
      'My orthodontic practice is at Av. La Cultura 822, Wanchaq district, Cusco. Easy access next to the French Institute "Alianza Francesa" and a few minutes from the historic center. I see patients Monday–Friday and Saturday mornings.',
      {
        s1: {
          title: 'Address and references',
          p1: 'Av. La Cultura 822, Wanchaq, Cusco, Peru. A few minutes by taxi from the Main Square. You can request exact location via WhatsApp when booking.',
        },
        s2: {
          title: 'Opening hours',
          p1: 'Monday–Friday 9:00 AM–7:00 PM and Saturday 9:00 AM–1:00 PM. Appointments outside hours only with prior coordination with me.',
        },
        s3: {
          title: 'Contact',
          p1: 'Phone: (084) 607 539. Online booking available 24/7. I provide care in Spanish and English for local and international patients.',
        },
      },
      {
        b1: 'Central Cusco area',
        b2: 'Extended weekday hours',
        b3: 'Saturday mornings',
        b4: 'Booking and WhatsApp available',
      }
    ),
    firstConsult: page(
      'First Orthodontic Consultation Cusco | Smile Up Guide',
      'Guide to your first orthodontic consultation in Cusco: evaluation, braces and aligner options, timelines and online booking with Dr. Paniura.',
      'First orthodontic consultation in Cusco',
      'This guide summarizes what happens at your initial evaluation: from clinical records to my treatment proposal with braces, aligners or maxillary orthopedics. Ideal if orthodontics in Cusco is new to you.',
      {
        s1: {
          title: 'Purpose of the consultation',
          p1: 'I determine whether active orthodontics is needed, when to start and which technique fits your lifestyle and budget best.',
        },
        s2: {
          title: 'Frequently asked questions',
          p1: 'Does it hurt? Starts may cause mild pressure for a few days. Age limit? Treatments exist for children, teens and adults. Cost? Depends on the case; I review details at evaluation.',
        },
        s3: {
          title: 'Book now',
          p1: 'Use the online calendar to choose your time. If you read my aligner guide on the blog, bring your questions — I answer them in person with your real diagnosis.',
        },
      },
      {
        b1: 'Educational content before the visit',
        b2: 'Answers to common questions',
        b3: 'Direct link to booking',
        b4: 'Complement to the orthodontics blog',
      }
    ),
  },
};
